import BaseStore from "../base/BaseStore";
import Service from "../model/service/Service";

import { StoreActionType, ActionInterface } from '../constant/ActionConstant';
import AppDispatcher from "../dispatcher/AppDispatcher";

class UbereatsStore extends BaseStore {

    private _service: Service;

    constructor() {
        super();
        this._service = new Service();
    }

    public get service(): Service {
        return this._service;
    }

    setService(service: Service) {
        this._service = service;
        this.emitChange();
    }
}

const storeAction = (store: UbereatsStore) => {
    return (action: ActionInterface) => {
        switch(action.type) {
            case StoreActionType.SET_UBEREATS_SERVICE:
                store.setService(action.data);
                break;
        }
    }
}

const UbereatsStoreShared = new UbereatsStore();
UbereatsStoreShared.dispatchToken = AppDispatcher.register(storeAction(UbereatsStoreShared) as (payload: unknown) => void);

export default UbereatsStoreShared;
export const store = UbereatsStore;
export const action = storeAction;